import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { SelectorMode } from '../../_common/selector-mode/selector-mode'
import { Speaker } from './../../../API.service'

@Component({
    selector: 'pia3-speaker-selector-multi-with-search',
    templateUrl: './pia3-speaker-selector-multi-with-search.component.html',
    styleUrls: ['./pia3-speaker-selector-multi-with-search.component.scss'],
})
export class Pia3SpeakerSelectorMultiWithSearchComponent implements OnInit {
    @Input('clientID') clientID!: string
    selectorMode: string = SelectorMode.MULTI_WITH_SEARCH
    @Output('speakerSelected') speakersSelected = new EventEmitter<Speaker[]>()

    constructor() {}

    ngOnInit() {}

    _speakerSelected($event) {
        this.speakersSelected.emit($event)
    }
}
